// @flow

import NestedResource from 'speed-js-core/src/api/NestedResource';

export default class CaseCurrentAlarmsResource extends NestedResource {
    basePath: string = 'cases/cases/{parent}/alarms/';

    objectPath: string = 'cases/cases/{parent}/alarms/{ident}/';
}
